import { UUID } from '@/types';
import { TSavedQueryPreset } from '@/features/dashboard/components/DashboardFilterModal/components/PresetChoices/types';
import ColumnTypeData, { ColumnType } from './ColumnType';
import Column from './Column';
import ColumnName from './ColumnName';

class DashboardFilterRef {
  constructor(
    readonly _id: UUID,
    readonly _name: string,
    readonly _columnType: ColumnTypeData,
    readonly _series: UUID[],
    readonly _presets: unknown,
    readonly savedQueryPresets: Maybe<TSavedQueryPreset>,
  ) {}

  static buildFromServer(
    serverObj: Omit<DashboardFilterRef, '_columnType'> & {
      _columnType: ColumnType;
    },
  ) {
    return new DashboardFilterRef(
      serverObj._id,
      serverObj._name,
      new ColumnTypeData(serverObj._columnType, true),
      serverObj._series,
      serverObj._presets,
      serverObj.savedQueryPresets,
    );
  }

  id() {
    return this._id;
  }

  name() {
    return this._name;
  }

  columnType() {
    return this._columnType;
  }

  series() {
    return this._series;
  }

  asColumn() {
    return new Column(new ColumnName('x', this.name()), this.columnType(), []);
  }

  presets() {
    return this._presets;
  }
}

export default DashboardFilterRef;
